<template>
    <b-modal id="my-modal" centered hide-header hide-footer body-class="p-0" ref="command-modal">
        <div class="modal-header bg-primary d-flex justify-content-between">
            <div class="device-modal d-flex flex-row align-items-center">
                <img :src="require(`@/assets/img/devices/${device?.icon || '0'}.png`)" />
                <p class="text-light m-0 fs-4 ms-2">{{ device?.name || 'NaN' }}</p>
            </div>
            <div class="close-modal d-flex" @click="close">
                <img src="@/assets/img/close.svg" />
            </div>
        </div>
        <div class="modal-body d-flex flex-wrap justify-content-center">
            <div class="item-command p-3" @click="clickCommand('LOCK_COMMAND')" v-if="isActive('lock')">
                <img src="@/assets/img/commands/bloqueo.svg" />
                <p class="m-0 mt-1 fw-bold">Bloqueo</p>
            </div>
            <div class="item-command p-3" @click="clickCommand('UNLOCK_COMMAND')" v-if="isActive('unlock')">
                <img src="@/assets/img/commands/desbloqueo.svg" />
                <p class="m-0 mt-1 fw-bold">Desbloqueo</p>
            </div>
            <div class="item-command p-3" @click="findDevice">
                <img src="@/assets/img/commands/buscar.png" />
                <p class="m-0 mt-1 fw-bold">Buscar</p>
            </div>
            <div class="item-command p-3" @click="clickCommand('OPEN_LATCHES_COMMAND')" v-if="isActive('latches')">
                <img src="@/assets/img/commands/pestillos.png" />
                <p class="m-0 mt-1 fw-bold">Pestillos</p>
            </div>
            <div class="item-command p-3" @click="showNotes" v-if="isActive('notes')">
                <DeviceNotes ref="modal-device-notes"></DeviceNotes>
                <img src="@/assets/img/commands/notas.svg" />
                <p class="m-0 mt-1 fw-bold">Notas</p>
            </div>
            <div class="item-command p-3" v-if="isActive('share_position')">
                <img src="@/assets/img/commands/share-position.svg" />
                <p class="m-0 fw-bold text-center" style="line-height: 18px">Compartir Ubicación</p>
            </div>
            <div class="item-command p-3" @click="clickCommand('RESET')" v-if="isActive('reset')">
                <img src="@/assets/img/commands/reset.svg" />
                <p class="m-0 mt-1 fw-bold text-center" style="line-height: 18px">Reiniciar</p>
            </div>
            <div
                class="item-command p-3"
                @click="showOdometer"
                v-if="isActive('odometer') || isActive('virtual_odometer')"
            >
                <SetOdometer ref="modal-odometer" @updateOdometer="sendOdometer"></SetOdometer>
                <img src="@/assets/img/commands/odometer.svg" />
                <p class="m-0 mt-1 fw-bold text-center" style="line-height: 18px">Odómetro</p>
            </div>
            <div class="item-command p-3" @click="showHorometer" v-if="isActive('horometer')">
                <SetHorometer ref="modal-horometer" @updateHorometer="sendHorometer"></SetHorometer>
                <img src="@/assets/img/commands/horometer.svg" />
                <p class="m-0 mt-1 fw-bold text-center" style="line-height: 18px">Horómetro</p>
            </div>
            <div class="item-command p-3" @click="toggleTxControl" v-if="userTxControl">
                <img src="@/assets/img/commands/desactivateTx.svg" v-if="!device.disabled" />
                <img src="@/assets/img/commands/activateTx.svg" v-if="device.disabled" />
                <p class="m-0 mt-1 fw-bold text-center" style="line-height: 18px" v-if="!device.disabled">Desactivar</p>
                <p class="m-0 mt-1 fw-bold text-center" style="line-height: 18px" v-if="device.disabled">Activar</p>
            </div>
        </div>
    </b-modal>
</template>

<script lang="ts">
import AccumulatorsService from '@/api/services/accumulators.service'
import DeviceService from '@/api/services/device.service'
import IServiceDto from '@/models/dto/service.dto'
import { ActionType } from '@/models/enum-types/action-type.enum'
import devicesModule from '@/store/modules/devices.module'
import ModemStrategyFactory from '@/strategies/modem.strategy/modem.strategy.factory'
import { MapsUtil } from '@/utils/maps.util'
import { Component, Vue, Watch } from 'vue-property-decorator'
import DeviceNotes from './DeviceNotes.vue'
import SetHorometer from './SetHorometer.vue'
import SetOdometer from './SetOdometer.vue'
import globalModule from '@/store/modules/global.module'

@Component({
    components: { SetOdometer, SetHorometer, DeviceNotes },
})
export default class DeviceCommand extends Vue {
    deviceId = 0
    device: any = {}
    services: IServiceDto[] = []

    get userTxControl() {
        return globalModule.userTxControl
    }

    @Watch('deviceId', { immediate: true })
    async onChangeDevice(deviceId: number) {
        this.device = (await devicesModule.getDevicebyId(deviceId)) || {}
        this.services = this.device.attributes?.services || []
    }

    isActive(service: string) {
        return this.services.find((item) => item.name == service)?.value || false
    }

    close() {
        const modal: any = this.$refs['command-modal']
        modal.hide()
    }

    show() {
        const modal: any = this.$refs['command-modal']
        modal.show()
    }

    findDevice() {
        const device = devicesModule.devices.find((device) => device.id === this.deviceId)
        device?.position
            ? MapsUtil.openGoogleMaps(device?.position?.latitude, device?.position?.longitude)
            : alert('La unidad aún no ha Transmitido')
    }

    toggleTxControl() {
        DeviceService.updateTxState(this.deviceId, !this.device.disabled)
    }

    async clickCommand(action: string) {
        const commandType: ActionType = action as ActionType
        const device = devicesModule.devices.find((device) => device.id === this.deviceId)
        if (device) {
            if (await this.showBox(this.device.name)) {
                //SI SE ACEPTA LA CONFIRMACION
                try {
                    await ModemStrategyFactory.create(device.model)?.sendCommand(device.id, commandType)
                    alert('Comando Enviado con Éxito')
                } catch (error: any) {
                    if (error.response && error.response.data && error.response.data.includes('limit')) {
                        alert('Usuario con permisos limitados')
                    } else {
                        alert('Error al enviar el comando: ' + error.message)
                    }
                }
                
            }
        }
    }

    async showOdometer() {
        const device = devicesModule.devices.find((device) => device.id === this.deviceId)
        const attributes = device?.position?.attributes
        const virtualOdometer = device?.attributes?.services?.find((item) => item.name === 'virtual_odometer')?.value
        const modal: any = this.$refs['modal-odometer']
        modal.icon = device?.icon || '0'
        modal.plate = device?.name || 'NaN'
        modal.odometer = ((virtualOdometer ? attributes.totalDistance : attributes.odometer) / 1000).toFixed(2)
        modal.show()
    }

    async showHorometer() {
        const device = devicesModule.devices.find((device) => device.id === this.deviceId)
        const attributes = device?.position?.attributes
        const modal: any = this.$refs['modal-horometer']
        modal.icon = device?.icon || '0'
        modal.plate = device?.name || 'NaN'
        modal.horometer = attributes.hours || 0
        modal.show()
    }

    async showNotes() {
        const device = devicesModule.devices.find((device) => device.id === this.deviceId)
        const modal: any = this.$refs['modal-device-notes']
        modal.icon = device?.icon || '0'
        modal.plate = device?.name || 'NaN'
        modal.show(this.deviceId)
    }

    async sendOdometer(newOdometer: string) {
        console.log(newOdometer)
        const device = devicesModule.devices.find((device) => device.id === this.deviceId)
        const virtualOdometer = device?.attributes?.services?.find((item) => item.name === 'virtual_odometer')?.value
        if (device) {
            if (await this.showBox(this.device.name)) {
                //SI SE ACEPTA LA CONFIRMACION
                virtualOdometer
                    ? await AccumulatorsService.setVirtualOdometer(device.id, Number(newOdometer))
                    : await ModemStrategyFactory.create(device.model)?.sendCommand(
                          device.id,
                          ActionType.ODOMETER_COMMAND,
                          newOdometer
                      )
                alert('Odómetro actualizado con Éxito')
                const modal: any = this.$refs['modal-odometer']
                modal.close()
                this.close()
            }
        }
    }

    async sendHorometer(newHorometer: number) {
        const device = devicesModule.devices.find((device) => device.id === this.deviceId)
        if (device) {
            if (await this.showBox(this.device.name)) {
                //SI SE ACEPTA LA CONFIRMACION
                await AccumulatorsService.setVirtualHorometer(device.id, newHorometer)
                alert('Horómetro actualizado con Éxito')
                const modal: any = this.$refs['modal-horometer']
                modal.close()
                this.close()
            }
        }
    }

    async showBox(plate: string) {
        return this.$bvModal.msgBoxConfirm(`Confirmar Envío de Comando a la unidad ${plate}`, {
            title: 'Confirmar Acción',
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'danger',
            headerClass: 'text-light',
            headerBgVariant: 'primary',
            okTitle: 'Aceptar',
            cancelTitle: 'Cancelar',
            footerClass: 'p-2',
            hideHeaderClose: false,
            centered: true,
        })
    }
}
</script>
<style lang="sass">
.modal-header
    height: 60px !important
    img
        height: 45px

.close-modal
    height: 20px
    cursor: pointer
    transition: all .1s ease
    &:active
        transform: scale(0.9)

    img
        height: 100%
.item-command
    display: flex
    justify-content: center
    align-items: center
    flex-direction: column
    width: 120px
    height: 120px
    transition: all .1s ease
    cursor: pointer
    border-radius: 5px
    border-style: outset
    border-color: #1976D2
    border-width: 5px
    margin: 5px
    &:active
        transform: scale(0.95)
    img
        width: 80%

.modal-container
    position: absolute
    z-index: 999
    width: 100%
    height: 100%
    background: rgb(0 0 0 / 48%)
</style>
